import React from "react";

function BlockchainExpertise() {
  return (
    <>
      <div
        className="faq-style-one-area accordion-secondary blurry-shape-right-bottom default-padding bg-gray"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/7.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-6">
              <div className="faq-style-one-info">
                <h4 className="sub-title">Question &amp; Answer</h4>
                <h2 className="title split-lines">
                  Why Choose Xeer Technology for Your AMM DEX Development?
                </h2>
                {/* <a
                  href="#"
                  className="btn btn-style-one btn-dark mt-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  All Questions
                </a> */}
              </div>
            </div>
            <div className="col-xl-6 offset-xl-1 col-lg-6">
              <div className="accordion-style-one-items fade-up-anim">
                <div className="accordion" id="faqAccordion">
                  <div className="accordion-style-one-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Blockchain Expertise
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          Our team brings extensive experience in developing
                          decentralized finance solutions, ensuring your staking
                          platform is secure, scalable, and future-proof.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-style-one-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        User-Centric Design
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          We prioritize creating a seamless, intuitive user
                          experience that makes it easy for both new and
                          experienced users to engage with your platform.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-style-one-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        End-to-End Development
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          From initial concept design to post-launch support, we
                          handle every aspect of the development process to
                          ensure the success of your DeFi staking platform
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockchainExpertise;
